import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { CreateSkillVersionRequest } from "../SkillRecord";

import { skillsQueryKey } from "./useSkills";
import { skillVersionsQueryKey } from "./useSkillVersions";

interface Args {
  skillId: string;
  request: CreateSkillVersionRequest;
}

export function useCreateVersion(orgId: string | undefined) {
  const { skillService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ skillId, request }: Args) =>
      skillService.createVersion(skillId, request, { orgId }),
    onSuccess: (_data, { skillId }) => {
      void queryClient.invalidateQueries({
        queryKey: skillVersionsQueryKey(skillId),
      });
      void queryClient.invalidateQueries({ queryKey: skillsQueryKey(orgId) });
    },
  });
}
